import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import { Button, TextField, MenuItem } from "@mui/material";
import { useMapContext } from "./MapContext";

interface ReportIssueProps {
  streamId?: string;
  onSuccess: () => void;
}

const ReportIssue = (props: ReportIssueProps) => {
  const { selectedPoint, setSelectedPoint } = useMapContext();

  // State for the form.
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [timestamp, setTimestamp] = useState(new Date().toISOString());
  const [submitting, setSubmitting] = useState(false);

  // Submits the form to the n8n webhook.
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!selectedPoint || !description) return;
    setSubmitting(true);

    try {
      const webhookUrl = process.env.REACT_APP_N8N_INCIDENT_REPORT_WEBHOOK_URL;
      if (!webhookUrl) {
        throw new Error(
          "REACT_APP_N8N_INCIDENT_REPORT_WEBHOOK_URL is not defined"
        );
      }
      await axios.post(webhookUrl, {
        category,
        location: {
          latitude: selectedPoint.lat,
          longitude: selectedPoint.lng,
        },
        description,
        // TODO: This should be some global context
        streamId: props.streamId,
        timestamp,
      });
      alert("Report submitted!");
      resetForm();
      props.onSuccess();
    } catch (err) {
      alert("Submission failed");
    } finally {
      setSubmitting(false);
    }
  };

  // TODO: This should get called when the drawer is closed.
  const resetForm = () => {
    setSelectedPoint(null);
    setDescription("");
    setCategory("");
    setTimestamp("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="Timestamp"
        value={timestamp}
        onChange={(e) => setTimestamp(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        select
        label="Category"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        fullWidth
        margin="normal"
        required
      >
        <MenuItem value="" disabled>
          Select a category
        </MenuItem>
        <MenuItem value="illegal_dumping">Illegal Dumping</MenuItem>
        <MenuItem value="street_maintenance">Street Maintenance</MenuItem>
        <MenuItem value="park_maintenance">Park Maintenance</MenuItem>
        <MenuItem value="code_enforcement">Code Enforcement</MenuItem>
        <MenuItem value="parking_violation">Parking Violation</MenuItem>
        <MenuItem value="encampment">Encampment</MenuItem>
        <MenuItem value="illegal_fireworks">Illegal Fireworks</MenuItem>
        <MenuItem value="other">Other</MenuItem>
      </TextField>
      <TextField
        label="Latitude"
        value={selectedPoint?.lat}
        fullWidth
        margin="normal"
        InputProps={{ readOnly: true }}
      />
      <TextField
        label="Longitude"
        value={selectedPoint?.lng}
        fullWidth
        margin="normal"
        InputProps={{ readOnly: true }}
      />
      <TextField
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
        margin="normal"
        multiline
        rows={3}
        required
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        disabled={submitting}
        sx={{ marginTop: 2 }}
      >
        {submitting ? "Submitting..." : "Submit"}
      </Button>
    </form>
  );
};

export default ReportIssue;
